<template>
  <div class="def-pass-container">
    <!--def-top-title str-->
    <div class="def-top-title" v-if="initHosp.mode == '2' || !initHosp.hospLogoUrl">
      <div class="def-big-title">
        <h2>信息登记</h2>
      </div>
      <div class="def-sub-title"></div>
    </div>
    <div class="def-hosp-info" v-else>
      <img :src="initHosp.hospLogoUrl" class="logo" alt="">
      <h3 class="name">{{initHosp.hospName}}</h3>
    </div>
    <!--def-top-title end-->
    <div class="def-pass-form">
      <div class="form-row">
        <div class="row-icon">
          <img src="../../assets/images/icon-user.png" alt=""/>
        </div>
        <div class="row-inp">
          <input type="text" class="r-inp" name="name" v-model="name" placeholder="请输入姓名" @blur="upOnePx"/>
        </div>
      </div>
      <div class="form-row">
        <div class="row-icon">
          <img src="../../assets/images/icon-phone.png" alt=""/>
        </div>
        <div class="row-inp">
          <input type="text" class="r-inp" name="phone" :disabled="!editable" v-model="phone" maxlength="11" placeholder="请输入手机号" @blur="upOnePx"/>
        </div>
      </div>
      <div class="form-row">
        <div class="row-icon">
          <img class="idno" src="../../assets/images/icon-idno.png" alt=""/>
        </div>
        <div class="row-inp">
          <input type="text" class="r-inp" name="idNo" v-model="idNo" maxlength="18" placeholder="请输入身份证号" @blur="upOnePx"/>
        </div>
      </div>
    </div>
    <div class="def-pass-btn">
      <a href="javascript:;" class="active" @click="userInfoSub()">提交</a>
    </div>
    <div class="def-pass-tips">
      <p class="txt-tit">温馨提示</p>
      <p class="txt-con">1、为了您和家人的安全和健康，请如实填写个人手机和身份信息</p>
      <p class="txt-con">2、咨询完成后请及时操作结束本次咨询，避免占用医生资源；</p>
      <p class="txt-con">3、平台仅供患者在线咨询医生，实际确诊请到医院就诊为准。</p>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'

export default {
  name: 'userInfo',
  data () {
    return {
      name: '',
      phone: '',
      pwd: '',
      idNo: '',
      staffId: '',
      editable: true,
      keepLogin: false // 用户登录一次后，可以保持登录，除非用户清缓存或者自己操作登出
    }
  },
  created () {
    this.staffId = this.$route.query.staffId

    let phone = sessionStorage.getItem('USER-PHONE')
    if (/^1\d{10}/.test(phone)) {
      this.phone = phone
      this.editable = false
    }
    if (this.initHosp.mode === '2' || !this.initHosp.hospLogoUrl) { // 多院或者无logo
      document.title = '在线咨询'
    } else {
      document.title = '信息登记'
    }
  },
  computed: {
    ...mapGetters([
      'initHosp'
    ])
  },
  mounted () {
    // this.getAuto() // 是否直接登录
  },
  methods: {
    userInfoSub () {
      if (!this.name) {
        this.$toast('请输入姓名')
        return false
      }
      if (!this.phone) {
        this.$toast('请输入手机号')
        return false
      }
      if (!this.ckPhone(this.phone)) {
        this.$toast('请输入正确手机号')
        return false
      }
      if (!this.idNo) {
        this.$toast('请输入身份证号')
        return false
      }
      if (!this.ckIdNo(this.idNo)) {
        this.$toast('请输入正确身份证号')
        return false
      }
      this.showMoeld()
    },
    ckPhone (val) {
      let _reg = /^[1][0-9]{10}$/
      if (_reg.test(val)) {
        return true
      }
      return false
    },
    ckIdNo (val) {
      let _reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (_reg.test(val)) {
        return true
      }
      return false
    },
    // 温馨提示
    showMoeld () {
      let _html = `为了您和家人的安全和健康，请如实填写个人手机和身份信息，方便医院医生做好后续病情随访。咨询完成后请及时操作结束本次咨询，避免占用医生资源。平台仅供患者在线咨询医生，实际确诊请到医院就诊为准。愿国泰民安。
                    <div class='def-pass-model'>
                      <p class='txt-big'>请再次确认登记信息</p>
                      <p class='form-table'><span class='txt-tit table-left'>姓名：</span><span class='txt-info table-right'>${this.name}</span></p>
                      <p class='form-table'><span class='txt-tit table-left'>手机号码：</span><span class='txt-info table-right'>${this.phone}</span></p>
                      <p class='form-table'><span class='txt-tit table-left'>身份证号：</span><span class='txt-info table-right'>${this.idNo}</span></p>
                    </div>`

      this.$messagebox.confirm('', {
        title: '温馨提示',
        message: _html,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(action => {
        // 免密注册
        this.$http.regPhone({
          regType: '3',
          name: this.name,
          phone: this.phone,
          idNo: this.idNo,
          allowExistPhone: 'true' // 是否覆盖原手机
        }).then(res => {
          if (!res.userIm.imUserExtra) {
            this.$toast('该账号IM账户获取失败，请联系客服')
            return false
          }

          let imUserExtra = JSON.parse(res.userIm.imUserExtra)
          // 模拟存储云信登录账号
          this.$store.commit('setToken', res.sessionId)
          this.$store.commit('setUserInfo', res)
          this.$store.commit('setOpenId', res.userLogin.openId)
          // 设置cookie
          Cookies.set('openId', res.userLogin.openId, {expires: 7})
          Cookies.set('userToken' + this.$store.getters.platId, res.sessionId, {expires: 7})
          Cookies.set('userId', res.id, {expires: 7})
          Cookies.set('userInfo', res, {expires: 7})
          Cookies.set('uid', imUserExtra.accid)
          Cookies.set('sdktoken', imUserExtra.token)
          Cookies.set('sessionId', res.sessionId)
          Cookies.set('imDoctorId', imUserExtra.accid)
          window.localStorage.setItem('fromIm', res.userIm.imUserExtra)
          sessionStorage.setItem('userEnter', 'patient')
          // 用户登录一次后，可以保持登录，除非用户清缓存或者自己操作登出
          window.localStorage.setItem('keepLogin', JSON.stringify(true))
          this.$toast('登记成功')

          setTimeout(() => {
            if (this.staffId) {
              this.$router.replace({ path: '/doctorInfo', query: { staffId: this.staffId } })
            } else if (this.initHosp.mode === '1') {
              // initHosp.mode 为 1 代表单院
              this.$router.replace({ path: '/counselor' })
            } else if (this.initHosp.mode === '2') {
              // initHosp.mode 为 2 代表区域所有医院
              this.$router.replace({ path: '/hospitalList' })
            }
          }, 2000)
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 是否有自动登录缓存
    // getAuto () {
    //   this.keepLogin = JSON.parse(window.localStorage.getItem('keepLogin')) || false
    //   if (this.keepLogin) {
    //     if (this.staffId) {
    //       this.$router.replace({path: '/doctorInfo', query: {staffId: this.staffId}})
    //     } else {
    //       this.$router.replace({path: '/counselor'})
    //     }
    //   }
    // },
    // input、textarea失焦后页面滚动1像素
    upOnePx () {
      setTimeout(() => {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/userReg.vue